<template>
  <div class="invoice_mini">
    <app-info :order="order" />
    <h2><v-icon>mdi-truck-fast</v-icon> Shipping</h2>
    <ul>
      <li>
        <strong>Recipient Name : </strong><br>
        {{ order.shippingRecipient | uppercase }}
      </li>
      <li>
        <strong>Address information : </strong><br>
        <p>{{ order.shippingInfo | capitalize }}</p>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AppInfo from "../common/ComInfo.vue";
export default {
  components: {
    "app-info": AppInfo,
  },
  data() {
    return {
      items: {},
      order: {},
      payment: {},
    };
  },
  computed: {
    ...mapGetters({
      info: "misc/currentSale",
    }),
  },
  mounted() {
    this.getFromApi();
    Event.$emit("printSize");
  },
  methods: {
    active() {
      let id = this.info;
      if (this.$route.params.id) {
        id = this.$route.params.id;
      }
      return id;
    },
    getFromApi() {
      window.axios.get("/order/" + this.active()).then((response) => {
        this.$data.items = response.data.order.items;
        this.$data.order = response.data.order;
        this.$data.payment = response.data.payment;
      });
    },
  },
};
</script>
<style type="text/css" scoped>
ul li {
  font-size: 13px;
}
</style>
